var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 1.5H9.75V0H11.25V1.5H12C12.825 1.5 13.5 2.175 13.5 3V13.5C13.5 14.325 12.825 15 12 15H1.5C0.6675 15 0 14.325 0 13.5L0.0078125 3C0.0078125 2.175 0.6675 1.5 1.5 1.5H2.25V0H3.75V1.5ZM1.5 13.5H12V5.25H1.5V13.5ZM4.5 12H3V10.5H4.5V12ZM7.5 12H6V10.5H7.5V12ZM10.5 12H9V10.5H10.5V12ZM4.5 9H3V7.5H4.5V9ZM7.5 9H6V7.5H7.5V9ZM10.5 9H9V7.5H10.5V9Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlots);
export default __webpack_public_path__ + "static/media/slots.f4937aa8c118b33a6e33dd1502796357.svg";
export { ForwardRef as ReactComponent };